import { makeStyles } from '@material-ui/core'
import { alpha } from '@mui/material'
import { Theme } from '@styles/theme/theme'

const useStyles = makeStyles((theme: Theme) => ({
  form: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '32px'
    }
  },
  title: {
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '48px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
      lineHeight: '28px',
      letterSpacing: '-0.01em',
    }
  },
  description: {
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '24px',
    color: 'rgba(0, 0, 0, 0.5)',
    textAlign: 'center',
    maxWidth: '664px',
  },

  selectorContainer: {
    gap: 20,
    maxWidth: '524px',
    width: '100%',
    margin: '0 auto'
  },

  fieldset: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    }
  },

  button: {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    width: '203px',
    height: '56px',
  },

  buttonSelector: {
    padding: '16px',
    width: '524px',
    height: '56px',
    background: 'rgba(0, 0, 0, 0.05)',
    borderRadius: '8px',
    fontSize: '18px',
    lineHeight: '24px',
    margin: '4px 0',
    '&:hover': {
      background: `${alpha(theme.palette.primary.main, 0.3)} !important`,
      color: 'white',
    },
    '& span': {
      justifyContent: 'flex-start',
    },
    '& svg': {
      marginTop: 5,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '24px',
      textAlign: 'left',
      alignItems: 'center',
      '& span': {
        flex: 1,
      },
    }
  },

  buttonContent: {
    gap: 20,
    maxWidth: '524px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
    }
  },

  selected: {
    background: `${theme.palette.primary.main} !important`,
    color: 'white',
  },

  shortcut: {
    display: 'inline-block',
    padding: '4px',
    width: '24px',
    height: '24px',
    borderRadius: '4px',
    background: 'rgba(0, 0, 0, 0.1)',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '16px',
    marginRight: '5px',
  }

}))

export default useStyles
